module.exports = __webpack_public_path__ + "baddba61cdd43be6757966f44d9004b3.png";